import {
  HAWKER_PROFILE_MODULE,
  HAWKER_SESSION_ADMIN_MODULE,
  HAWKER_COMMISSARY_ASSIGNMENT_HISTORY_MODULE,
  HAWKER_SESSION_MODULE,
} from './routes';
import {
  ENTITY_TYPES,
  PermissionValue,
  SupportedAppCodes,
} from './shared/types';
import { IMenuItem } from './xenial-ux/interfaces';

/**
 * Mapping of routes to the permissions required to access them.
 * CAUTION: only support app_code, name fields for now
 */
export const ROUTES_PERMISSIONS: Record<
  string,
  IMenuItem['requiredPermissions']
> = {
  [HAWKER_PROFILE_MODULE]: [
    `${ENTITY_TYPES.HAWKER_CONFIG}.${PermissionValue.View}`,
    {
      app_code: SupportedAppCodes.XDM,
      name: `${ENTITY_TYPES.COMMISSION_RATE}.${PermissionValue.View}`,
    },
    {
      app_code: SupportedAppCodes.XDM,
      name: `${ENTITY_TYPES.PRODUCT}.${PermissionValue.View}`,
    },
    {
      app_code: SupportedAppCodes.XDM,
      name: `${ENTITY_TYPES.TAG}.${PermissionValue.View}`,
    },
    {
      app_code: SupportedAppCodes.XDM,
      name: `${ENTITY_TYPES.REPORTING_CATEGORY}.${PermissionValue.View}`,
    },
  ],
  [HAWKER_SESSION_MODULE]: [
    `${ENTITY_TYPES.HAWKER_SESSION}.${PermissionValue.View}`,
  ],
  [HAWKER_COMMISSARY_ASSIGNMENT_HISTORY_MODULE]: [
    `${ENTITY_TYPES.HAWKER_CONFIG}.${PermissionValue.View}`,
  ],
  [HAWKER_SESSION_ADMIN_MODULE]: [
    `${ENTITY_TYPES.HAWKER_CONFIG}.${PermissionValue.Edit}`,
    `${ENTITY_TYPES.HAWKER_CONFIG}.${PermissionValue.View}`,
  ],
};
